<template lang="pug">
b-modal#editBetLimit(
  ref="editBetLimit"
  :title="$t('ui.edit_bet_limit')"
  centered
  no-fade
  no-close-on-backdrop
  ok-only
  ok-variant="secondary"
  size="xl"
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  .row(v-if="limits" style="overflow: auto;")
    .col-lg-7.col-md-12
      template(v-if="limits['SPORTSBOOK']")
        .card.p-0.shadow-lg.pb-3.mb-3
          .card-header.p-1.border-bottom.border-light.bg-gradient-light
            .text-xs.text-dark.font-weight-bold.px-2.py-1.text-uppercase {{ $t("ui.sportsbook") }}
          .card-body.p-2
            .table-responsive
              table.table.table-b-0.m-0(style="min-width: 500px;")
                thead
                  tr
                    th.p-1(style="width: 60px;") {{ $t("ui.type") }}
                    th.p-1(style="width: 120px;") {{ $t("ui.minBet") }}
                    th.p-1 {{ $t("ui.maxBet") }}
                    th.p-1 {{ $t("ui.maxPerMatch") }}
                tbody
                  template(v-for="item in limits['SPORTSBOOK']")
                    tr.form-group(:key="item.sport_type")
                      td.p-1.align-middle
                        span.text-capitalize {{ item.sport_type }}
                      td.p-1.align-middle
                        input.form-control.form-control-sm.font-weight-bold.py-0.px-1(
                          type="number"
                          v-model="item.min_bet"
                          :min="min"
                          :max="max"
                          :class="{ 'border-danger' : item.min_bet_error }"
                          )
                      td.p-1.align-middle
                        input.form-control.form-control-sm.font-weight-bold.py-0.px-1(
                          type="number"
                          v-model="item.max_bet"
                          :min="min"
                          :max="max"
                          :class="{ 'border-danger' : item.max_bet_error }"
                          )
                      td.p-1.align-middle
                        input.form-control.form-control-sm.font-weight-bold.py-0.px-1(
                          type="number"
                          v-model="item.max_per_match"
                          :min="item.max_bet"
                          :max="mpm"
                          :class="{ 'border-danger' : item.max_per_match_error }"
                          )
                    tr
                      td.py-0.px-1
                      td.py-0.px-1
                        .d-block.text-xxs.text-right.text-grey ({{ $t("ui.min")}}: {{ $numeral(min).format('0,0a') }})
                      td.py-0.px-1
                        .d-block.text-xxs.text-right.text-grey ({{ $t("ui.max")}}: {{ $numeral(max).format('0,0a') }})
                      td.py-0.px-1
                        .d-block.text-xxs.text-right.text-grey ({{ $t("ui.range")}}: {{ $numeral(item.max_bet).format('0,0a') }} - {{ $numeral(mpm).format('0,0a') }})
          .card-footer.px-3.pt-2.pb-0.text-right
            button.btn.btn-danger.btn-md(v-if="!loading" type="button" @click="updateBetLimitSports")
              i.me-1
                b.fa.fa-save
              span {{ $t("ui.save") }}
            button.btn.btn-danger.btn-md(v-else type="button" :disabled="loading")
              i.me-1
                b.fa.fa-spinner.fa-spin
              span {{ $t("ui.save") }}
    .col-lg-5.col-md-12
      template(v-if="limits['LIVECASINO']")
        template(v-if="!isMember")
          .card.p-0.shadow-lg.pb-3.mb-2(style="min-width: 350px;")
            .card-header.p-1.border-bottom.border-light.bg-gradient-light
              .d-flex.align-items-center.justify-content-between
                .text-xs.text-dark.font-weight-bold.px-2.py-1.text-uppercase {{ $t("ui.livecasino") }}
            .card-body.px-3.pt-3.pb-2
              .row(v-if="limits['LIVECASINO']['bet_limits']" role="form")
                .col-lg-6.col-md-6.col-6(v-for="item, key in limits['LIVECASINO']['bet_limits']")
                  .form-group.p-0.m-0.mb-2
                    .form-check.form-switch.d-flex.align-items-center.justify-content-start
                      label.switch.switch-label.switch-info.mb-0
                        input(
                          type="checkbox"
                          class="switch-input"
                          v-model="limits['LIVECASINO']['bet_limits'][key]")
                        span(class="switch-slider" :data-checked="$t('ui.on')" :data-unchecked="$t('ui.off')")
                      b.form-check-label.text-info.m-0.ml-2.text-uppercase.text-truncate {{ $t("ui.package") }} {{ key }}
            .card-footer.px-3.pt-2.pb-0.text-right
              button.btn.btn-danger.btn-md(v-if="!loading" type="button" @click="updateBetLimitLiveCasino()")
                i.me-1
                  b.fa.fa-save
                span {{ $t("ui.save") }}
              button.btn.btn-danger.btn-md(v-else type="button" :disabled="loading")
                i.me-1
                  b.fa.fa-spinner.fa-spin
                span {{ $t("ui.save") }}
        template(v-else)
          .card.p-0.shadow-lg.pb-3.mb-2(style="min-width: 350px;")
            .card-header.p-1.border-bottom.border-light.bg-gradient-light
              .d-flex.align-items-center.justify-content-between
                .text-xs.text-dark.font-weight-bold.px-2.py-1.text-uppercase {{ $t("ui.livecasino") }} {{ limits['LIVECASINO']['bet_limit_package'] }}
            .card-body.px-3.pt-3.pb-2
              .row(v-if="limits['LIVECASINO']['bet_limits']" role="form")
                .col-lg-6.col-md-6.col-6(v-for="item, key in limits['LIVECASINO']['bet_limits']")
                  .form-group.p-0.m-0.mb-2
                    .form-check.form-switch.d-flex.align-items-center.justify-content-start
                      label.switch.switch-label.switch-info.mb-0
                        input(
                          type="radio"
                          class="switch-input"
                          :value="key"
                          v-model="limits['LIVECASINO']['bet_limit_package']")
                        span(class="switch-slider" :data-checked="$t('ui.on')" :data-unchecked="$t('ui.off')")
                      b.form-check-label.text-info.m-0.ml-2.text-uppercase.text-truncate {{ $t("ui.package") }} {{ key }}
            .card-footer.px-3.pt-2.pb-0.text-right
              button.btn.btn-danger.btn-md(v-if="!loading" type="button" @click="updateBetLimitLiveCasino()")
                i.me-1
                  b.fa.fa-save
                span {{ $t("ui.save") }}
              button.btn.btn-danger.btn-md(v-else type="button" :disabled="loading")
                i.me-1
                  b.fa.fa-spinner.fa-spin
                span {{ $t("ui.save") }}

      template(v-if="limits['LOTTERY']")
        template(v-if="!isMember")
          .card.p-0.shadow-lg.pb-3.mb-2(style="min-width: 350px;")
            .card-header.p-1.border-bottom.border-light.bg-gradient-light
              .d-flex.align-items-center.justify-content-between
                .text-xs.text-dark.font-weight-bold.px-2.py-1.text-uppercase {{ $t("ui.lottery") }}
            .card-body.px-3.pt-3.pb-2
              .row(v-if="limits['LOTTERY']['bet_limits']" role="form")
                .col-lg-6.col-md-6.col-6(v-for="item, key in limits['LOTTERY']['bet_limits']")
                  .form-group.p-0.m-0.mb-2
                    .form-check.form-switch.d-flex.align-items-center.justify-content-start
                      label.switch.switch-label.switch-info.mb-0
                        input(
                          type="checkbox"
                          class="switch-input"
                          v-model="limits['LOTTERY']['bet_limits'][key]")
                        span(class="switch-slider" :data-checked="$t('ui.on')" :data-unchecked="$t('ui.off')")
                      b.form-check-label.text-info.m-0.ml-2.text-uppercase.text-truncate {{ $t("ui.package") }} {{ key }}
            .card-footer.px-3.pt-2.pb-0.text-right
              button.btn.btn-danger.btn-md(v-if="!loading" type="button" @click="updateBetLimitLottery")
                i.me-1
                  b.fa.fa-save
                span {{ $t("ui.save") }}
              button.btn.btn-danger.btn-md(v-else type="button" :disabled="loading")
                i.me-1
                  b.fa.fa-spinner.fa-spin
                span {{ $t("ui.save") }}
        template(v-else)
          .card.p-0.shadow-lg.pb-3.mb-2(style="min-width: 350px;")
            .card-header.p-1.border-bottom.border-light.bg-gradient-light
              .d-flex.align-items-center.justify-content-between
                .text-xs.text-dark.font-weight-bold.px-2.py-1.text-uppercase {{ $t("ui.lottery") }}
            .card-body.px-3.pt-3.pb-2
              .row(v-if="limits['LOTTERY']['bet_limits']" role="form")
                .col-lg-6.col-md-6.col-6(v-for="item, key in limits['LOTTERY']['bet_limits']")
                  .form-group.p-0.m-0.mb-2
                    .form-check.form-switch.d-flex.align-items-center.justify-content-start
                      label.switch.switch-label.switch-info.mb-0
                        input(
                          type="radio"
                          class="switch-input"
                          :value="key"
                          v-model="limits['LOTTERY']['bet_limit_package']")
                        span(class="switch-slider" :data-checked="$t('ui.on')" :data-unchecked="$t('ui.off')")
                      b.form-check-label.text-info.m-0.ml-2.text-uppercase.text-truncate {{ $t("ui.package") }} {{ key }}
            .card-footer.px-3.pt-2.pb-0.text-right
              button.btn.btn-danger.btn-md(v-if="!loading" type="button" @click="updateBetLimitLottery")
                i.me-1
                  b.fa.fa-save
                span {{ $t("ui.save") }}
              button.btn.btn-danger.btn-md(v-else type="button" :disabled="loading")
                i.me-1
                  b.fa.fa-spinner.fa-spin
                span {{ $t("ui.save") }}
  .row
    .col
      b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  //- div(slot="modal-cancel")
  //-   SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  //- div(slot="modal-ok")
  //-   SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, numeric, decimal, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);

import xhr from "@/plugins/xhr.js";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      test: null,
      isMember: false,
      item: {},
      accountId: "",
      min: config.LIMIT.MIN,
      max: config.LIMIT.MAX,
      mpm: config.LIMIT.MPM,
      packages: config.LIMIT.PACKAGES,
      limits: {
        LIVECASINO: {},
        LOTTERY: {},
        SPORTSBOOK: {}
      },
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {},
  methods: {
    checkBetLimit() {
      this.reset();
      if (this.limits == undefined) {
        return false;
      }
      if (this.limits["SPORTSBOOK"] == undefined) {
        return false;
      }

      var isError = true;
      for (var i in this.limits["SPORTSBOOK"]) {
        var j = this.limits["SPORTSBOOK"][i];
        if (j) {
          if (j.min_bet < this.min) {
            this.$set(j, "min_bet_error", true);
            isError = false;
          }
          if (j.max_bet < this.min) {
            this.$set(j, "max_bet_error", true);
            isError = false;
          }
          if (j.min_bet > this.max) {
            this.$set(j, "min_bet_error", true);
            isError = false;
          }
          if (j.max_bet > this.max) {
            this.$set(j, "max_bet_error", true);
            isError = false;
          }
          if (j.max_per_match < j.max_bet) {
            this.$set(j, "max_per_match_error", true);
            isError = false;
          }
          if (j.max_per_match > this.mpm) {
            this.$set(j, "max_per_match_error", true);
            isError = false;
          }
        }
      }

      return isError;
    },
    updateBetLimitLiveCasino(e) {
      if (this.loading) return;
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        target_account_id: this.accountId
      };

      if (!this.isMember) {
        var b = [];
        for (var i in this.limits["LIVECASINO"]["bet_limits"]) {
          if (this.limits["LIVECASINO"]["bet_limits"][i]) {
            b.push(i);
          }
        }
        if (!b.includes("A")) {
          this.$swal({
            title: this.$t("ui.error"),
            text: this.$t("error.packageARequired"),
            type: "error"
          });
          return;
        }
        args["bet_limit_packages"] = b.join(",");
      } else {
        args["bet_limit_packages"] = this.limits["LIVECASINO"]["bet_limit_package"];
      }

      this.loading = true;
      var endpoint = xhr.ACCOUNT.updateBetLimitLiveCasino;
      if (this.isMember == true) {
        endpoint = xhr.ACCOUNT.updateMemberBetLimitLiveCasino;
      }
      xhr
        .doRequest(args, endpoint)
        .then(res => {
          this.loading = false;
          this.feedback.success = res.success;
          this.feedback.status = res.status;
          if (res.success == true) {
            this.$helpers.showDialog(this.$t("ui.edit_bet_limit"), this.$t("message.success"), "success");
          } else {
            this.$helpers.handleFeedback(this.feedback.status);
          }
          this.populate();
          this.$emit("done");
        })
        .catch(res => {
          this.loading = false;
          if (res.status.toLowerCase() == "nochanges") {
          } else {
            this.feedback.success = false;
            this.feedback.status = res.status;
          }
          this.populate();
          this.$emit("done");
        });
    },
    updateBetLimitLottery(e) {
      if (this.loading) return;
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        target_account_id: this.accountId
      };

      if (!this.isMember) {
        var b = [];
        for (var i in this.limits["LOTTERY"]["bet_limits"]) {
          if (this.limits["LOTTERY"]["bet_limits"][i]) {
            b.push(i);
          }
        }
        if (!b.includes("A")) {
          this.$swal({
            title: this.$t("ui.error"),
            text: this.$t("error.packageARequired"),
            type: "error"
          });
          return;
        }
        args["bet_limit_packages"] = b.join(",");
      } else {
        args["bet_limit_packages"] = this.limits["LOTTERY"]["bet_limit_package"];
      }
      this.loading = true;
      var endpoint = xhr.ACCOUNT.updateBetLimitLottery;
      if (this.isMember == true) {
        endpoint = xhr.ACCOUNT.updateMemberBetLimitLottery;
      }
      xhr
        .doRequest(args, endpoint)
        .then(res => {
          this.loading = false;
          this.feedback.success = res.success;
          this.feedback.status = res.status;
          if (res.success == true) {
            this.$helpers.showDialog(this.$t("ui.edit_bet_limit"), this.$t("message.success"), "success");
          } else {
            this.$helpers.handleFeedback(this.feedback.status);
          }
          this.populate();
          this.$emit("done");
        })
        .catch(res => {
          this.loading = false;
          if (res.status.toLowerCase() == "nochanges") {
          } else {
            this.feedback.success = false;
            this.feedback.status = res.status;
          }
          this.populate();
          this.$emit("done");
        });
    },
    updateBetLimitSports(e) {
      if (!this.checkBetLimit()) {
        return;
      }
      if (this.loading) return;
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        target_account_id: this.accountId
      };
      for (var i in this.limits["SPORTSBOOK"]) {
        var d = this.limits["SPORTSBOOK"][i];
        args[i.toLowerCase() + "_min_bet"] = d["min_bet"];
        args[i.toLowerCase() + "_max_bet"] = d["max_bet"];
        args[i.toLowerCase() + "_max_per_match"] = d["max_per_match"];
      }
      this.loading = true;
      var endpoint = xhr.ACCOUNT.updateBetLimitSports;
      if (this.isMember == true) {
        endpoint = xhr.ACCOUNT.updateMemberBetLimitSports;
      }
      xhr
        .doRequest(args, endpoint)
        .then(res => {
          this.loading = false;
          this.feedback.success = res.success;
          this.feedback.status = res.status;
          if (res.success == true) {
            this.$helpers.showDialog(this.$t("ui.edit_bet_limit"), this.$t("message.success"), "success");
          } else {
            this.$helpers.handleFeedback(this.feedback.status);
          }
          this.populate();
          this.$emit("done");
        })
        .catch(res => {
          this.loading = false;
          if (res.status.toLowerCase() == "nochanges") {
          } else {
            this.feedback.success = false;
            this.feedback.status = res.status;
          }
          this.populate();
          this.$emit("done");
        });
    },
    populate() {
      this.loading = true;
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        target_account_id: this.accountId
      };
      var endpoint = xhr.ACCOUNT.getBetLimit;
      if (this.isMember == true) {
        endpoint = xhr.ACCOUNT.getMemberBetLimit;
      }
      xhr
        .doRequest(args, endpoint)
        .then(res => {
          this.loading = false;
          if (res.success == true) {
            var data = res.data;
            if (data["Live"] && data["Live"].length > 0) {
              this.$set(this.limits, "LIVECASINO", data["Live"][0]);
              this.limits["LIVECASINO"]["package"] = this.limits["LIVECASINO"]["bet_limit_package"].toUpperCase().split(",");
              this.limits["LIVECASINO"]["bet_limits"] = {};
              // for (var i in this.packages) {
              //   var p1 = this.packages[i];
              //   var p2 = this.limits["LIVECASINO"]["package"][i];
              //   this.limits["LIVECASINO"]["bet_limits"][p1] = p1 == p2;
              // }
              for (var i in this.packages) {
                var p1 = this.packages[i];
                this.limits["LIVECASINO"]["bet_limits"][p1] = false;
              }
              for (var j in this.limits["LIVECASINO"]["package"]) {
                var p2 = this.limits["LIVECASINO"]["package"][j];
                this.limits["LIVECASINO"]["bet_limits"][p2] = true;
              }
            }
            if (data["Lottery"] && data["Lottery"].length > 0) {
              this.$set(this.limits, "LOTTERY", data["Lottery"][0]);
              this.limits["LOTTERY"]["package"] = this.limits["LOTTERY"]["bet_limit_package"].toUpperCase().split(",");
              this.limits["LOTTERY"]["bet_limits"] = {};
              // for (var i in this.packages) {
              //   var p1 = this.packages[i];
              //   var p2 = this.limits["LOTTERY"]["package"][i];
              //   this.limits["LOTTERY"]["bet_limits"][p1] = p1 == p2;
              // }
              for (var i in this.packages) {
                var p1 = this.packages[i];
                this.limits["LOTTERY"]["bet_limits"][p1] = false;
              }
              for (var j in this.limits["LOTTERY"]["package"]) {
                var p2 = this.limits["LOTTERY"]["package"][j];
                this.limits["LOTTERY"]["bet_limits"][p2] = true;
              }
            }
            if (data["Sport"] && data["Sport"].length > 0) {
              if (this.limits["SPORTSBOOK"] == undefined) {
                this.limits["SPORTSBOOK"] = {};
              }
              for (var k = 0; k < data["Sport"].length; k++) {
                this.$set(this.limits["SPORTSBOOK"], data["Sport"][k]["sport_type"], data["Sport"][k]);
              }
            }
            // console.log(this.limits);
          } else {
            this.limits = {
              LIVECASINO: {},
              LOTTERY: {},
              SPORTSBOOK: {}
            };
          }
        })
        .catch(res => {
          this.loading = false;
          this.limits = {
            LIVECASINO: {},
            LOTTERY: {},
            SPORTSBOOK: {}
          };
        });
    },
    done(evt) {
      // evt.preventDefault();
      // this.submit();
      this.$refs.editBetLimit.hide();
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.accountId = this.item.account_id;
      this.populate();
    }
  }
};
</script>
